import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Box, Typography } from '@mui/material';
import { CustomSelect, CustomButton, CustomCalendar, CustomModal, CustomReactSelect } from '../../../../shared';
import { PlusIcon, Trash, CalendarIcon } from '../../../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { actions as ChannelActions } from '../../../../../redux/reducers/adminSettingsReducer';
import { deleteQuery } from '../../../../../redux/thunks/triggerThunk';
import ConfirmationModal from '../../../../shared/confirmationModal';
import ConfirmationDelete from '../confirmationDelete';
import { actions as companyActions } from '../../../../../redux/reducers/companyReducer';
import EditCreateChannelActions from '../editCreateChannelActions'

const FilterBar = (props) => {
    const navigate = useNavigate();
    const { selected } = useSelector(state => state.query);
    const [open, setOpen] = useState(false);
    const { isLoading, channelActions } = useSelector((state) => state.adminSettings)
    const { type, showModal } = channelActions
    const { companyOptions, company: selectedCompany } = useSelector((state) => state.company);
    const dispatch = useDispatch()

    const handleDeleteSelected = () => {
        if(selected.length>0){
            dispatch(deleteQuery({companyId: selectedCompany.id, data: {ids: selected}})).then(result => {
                if(result.payload.status_code === 200){
                    dispatch(actions.setSelectAllFalse())
                    onclose();
                }
            })
        }
    };

    const onclose = () =>{
        setOpen(!open)
    };
   
    return (
        <>
             <Grid className="flex-row-space-between pb-24px mt-10px">
                <Grid className='d-flex gap-12' xs={6}>
                </Grid>
                <Grid xs={6} className='d-flex gap-12'>
                    <Box className="ml-auto">
                    <CustomButton
                        title="Create New"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<PlusIcon color='#FFFFFF' />}
                        handleClick={()=>dispatch(ChannelActions.handleChannelActionModal("Create"))}
                    />
                   {/*  <CustomButton
                        title="Delete"
                        icon={<Trash />}
                        handleClick={()=> setOpen(true)}
                    /> */}
                    </Box>
                   
                </Grid>
            </Grid>
            <CustomModal 
                modalOpen={showModal} 
                component={<EditCreateChannelActions handleClose={()=>dispatch(ChannelActions.handleChannelActionModal(""))} />}
                onClose={()=>dispatch(ChannelActions.handleChannelActionModal(""))}
            />
           <ConfirmationDelete open={open} onClosed={onclose} onConfirms={handleDeleteSelected}/>
        </>
    );
};

export default FilterBar;
